import MemberHomeFirstTouch from './MemberHomeFirstTouch'

export default MemberHomeFirstTouch
// eslint-disable-next-line import/export
export * from './MemberHomeFirstTouch'
// eslint-disable-next-line import/export
export * from './utils'
